export const GITHUB_ALERT_STATUS = 'GITHUB_ALERT_STATUS';
